"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootLink = exports.Root = exports.Name = exports.Info = exports.Description = exports.Buttons = exports.Brand = void 0;
var _mui = require("@ori-ui/mui");
var _common = require("../../../common");
const rootStyles = theme => ({
  background: theme.palette.common.white,
  borderRadius: '10px',
  boxShadow: _mui.SHADOW_LEVEL1,
  cursor: 'default',
  display: 'grid',
  fontFamily: _common.FONT_SANS_ORI,
  overflow: 'hidden',
  padding: theme.spacing(3),
  position: 'relative',
  textDecoration: 'none',
  WebkitTapHighlightColor: 'transparent',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    padding: theme.spacing(1),
    '&:hover': {
      boxShadow: _mui.SHADOW_LEVEL1
    }
  }
});
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  ...rootStyles(theme)
}));
const RootLink = exports.RootLink = (0, _mui.styled)('a')(({
  theme
}) => ({
  ...rootStyles(theme),
  [theme.breakpoints.up('sm')]: {
    cursor: 'pointer',
    display: 'flex',
    padding: theme.spacing(1),
    '&:hover': {
      boxShadow: _mui.SHADOW_LEVEL2
    }
  }
}));
const Brand = exports.Brand = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  fontSize: '1.2rem',
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: '2.4px',
  textAlign: 'center',
  textTransform: 'uppercase',
  svg: {
    fontSize: '1.8rem'
  },
  [theme.breakpoints.up('sm')]: {
    textAlign: 'left'
  }
}));
const Name = exports.Name = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  boxOrient: 'vertical',
  display: '-webkit-box',
  marginTop: theme.spacing(1),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2
}));
const Description = exports.Description = (0, _mui.styled)(_mui.Typography)(() => ({
  boxOrient: 'vertical',
  display: '-webkit-box',
  lineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2
}));
const Buttons = exports.Buttons = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexFlow: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    flexFlow: 'row'
  }
}));
const Info = exports.Info = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  overflow: 'hidden',
  [theme.breakpoints.up('sm')]: {
    alignSelf: 'center',
    padding: theme.spacing(2, 5, 2, 6),
    width: '100%'
  }
}));
